<template>
  <div>
    <p style="font-size: 16px; color: rgba(0, 0, 0, 0.85); font-weight: 800; margin-bottom: 20px;margin-top: 30px;font-size: 20px">{{language['system.loginEmailVerify']}}</p>
    <a-form-model ref="form" :model="model" :rules="validatorRules">
      <!--<a-form-model-item required prop="mobile">
        <a-input v-model="model.mobile" size="large" type="text" placeholder="请输入手机号">
          <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-model-item>-->
      <!--<p>我们已向您的邮箱 {{model.email}} 发送验证码，请输入验证码进行登录</p>-->
      <p><span style="font-size: 15px">{{model.title}}</span></p>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="16">
          <a-form-model-item  prop="emailCaptcha">
            <a-input v-model="model.emailCaptcha" size="large" type="text" :placeholder="language['system.verificationCode']">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <a-button
            class="getCaptcha"
            tabindex="-1"
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha2fa"
            :title="!state.smsSendBtn && language['portal.front.getCode'] || (state.time+' s')"
            v-text="!state.smsSendBtn && language['portal.front.getCode'] || (state.time+' s')"></a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
  import { postAction } from '@api/manage'
  import { mapActions } from 'vuex'

  export default {
    name: 'VerifyMail',
    props: {
    },
    data(){
      return {
        model:{
          username:'',
          password:'',
          checkKey:'',
          email: '',
          emailCaptcha: '',
          title:'',
        },
        //手机号登录用
        state: {
          time: 60,
          smsSendBtn: false,
        },
        /*validatorRules:{
          emailCaptcha: [{
            required: true, message: this.$store.getters.language['system.verificationCode']
          }]
        },*/
        //phone: '',

      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        return {
          emailCaptcha: [{
            required: true, message: this.$store.getters.language['system.verificationCode']
          }]
        }
      }
    },
    methods:{
      ...mapActions(['PhoneLogin2fa','verifyEmailLogin']),
      handleLogin(rememberMe){
        this.validateFields([ 'emailCaptcha' ], (err) => {
          if (!err) {
            let loginParams = {
              username: this.model.username,
              password: this.model.password,
              email:this.model.email,
              emailCaptcha:this.model.emailCaptcha,
              checkKey: this.model.checkKey,
              remember_me: rememberMe,
              loginSource:"1",
            }
            this.verifyEmailLogin(loginParams).then((res) => {
              if(res.success){
                this.$emit('success', res.result)
              }else{
                this.model.emailCaptcha = ""
                this.$emit('fail',res.result)
              }
            }).catch((err) => {
              this.model.emailCaptcha = ""
              this.$emit('fail', err)
            });
          }else{
            this.$emit('validateFail')
          }
        })
      },
      // 校验手机号
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          if(this.phone!==value){
            callback("您的手机号码不正确!");
          }
          callback();
        }else{
          callback("您的手机号码格式不正确!");
        }
      },
      //获取验证码
      getCaptcha2fa (e) {
        e.preventDefault();
        let that = this;
        that.validateFields([  ], (err) => {
            if (!err) {
              that.state.smsSendBtn = true;
              let interval = window.setInterval(() => {
                if (that.state.time-- <= 0) {
                  that.state.time = 60;
                  that.state.smsSendBtn = false;
                  window.clearInterval(interval);
                }
              }, 1000);

              const hide = that.$message.loading(that.language['portal.front.code.sending'], 0);
              let smsParams = {};
              smsParams.email=that.model.email;
              smsParams.username=that.model.username;
              postAction("/sys/sendVerifyMail",smsParams)
                .then(res => {
                  if(!res.success){
                    setTimeout(hide, 0);
                    that.cmsFailed(res.message);
                  }
                  setTimeout(hide, 500);
                })
                .catch(err => {
                  setTimeout(hide, 1);
                  clearInterval(interval);
                  that.state.time = 60;
                  that.state.smsSendBtn = false;
                  that.requestFailed(err);
                });
            }
          }
        );
      },
      cmsFailed(err){
        let that = this;
        that.$notification[ 'error' ]({
          message: that.language['portal.interface.code.error'],
          description:err,
          duration: 4,
        });
      },
      /**
       * 验证字段
       * @param arr
       * @param callback
       */
      validateFields(arr, callback){
        let promiseArray = []
        for(let item of arr){
          let p = new Promise((resolve, reject) => {
            this.$refs['form'].validateField(item, (err)=>{
              if(!err){
                resolve();
              }else{
                reject(err);
              }
            })
          });
          promiseArray.push(p)
        }
        Promise.all(promiseArray).then(()=>{
          callback()
        }).catch(err=>{
          callback(err)
        })
      },


    }

  }
</script>

<style scoped>
  .getCaptcha{
    display: block;
    width: 100%;
    height: 40px;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  }
</style>